export default __webpack_public_path__ + "static/media/frostangel.26c14a61.png";